// opervex-frontend/src/hooks/useCommandActions.js

import { useCallback, useState } from "react";
import { useAuth } from "../contexts/AuthContext";

const permissionByAction = {
  create: "Create",
  change: "Change",
  read: "Read",
  delete: "Delete",
  print: "Print",
  reversal: "Reversal",
  import: "Import",
  save: "Save",
  closedFiscal: "ClosedFiscal",
};

export const DEFAULT_ACTIONS = Object.freeze({
  create: false,
  change: false,
  read: false,
  delete: false,
  print: false,
  reversal: false,
  import: false,
  save: false,
  closedFiscal: false,
});

const useCommandActions = (command, defaultActions = DEFAULT_ACTIONS) => {
  const { roles } = useAuth();
  const [actions, setActions] = useState(() => ({ ...defaultActions }));

  const commandAction = useCallback(
    (requestedActions) => {
      const permission = roles?.find((role) => role.command === command);
      if (!permission) {
        setActions({ ...defaultActions });
        return;
      }

      const allowedActions = new Set((permission.actions || []).map((action) => action.key));
      const nextActions = { ...requestedActions };

      Object.entries(permissionByAction).forEach(([action, permissionKey]) => {
        if (!nextActions[action]) return;
        if (action === "save") {
          nextActions.save = allowedActions.has(permissionKey) || allowedActions.has("Create") || allowedActions.has("Change");
          return;
        }
        nextActions[action] = allowedActions.has(permissionKey);
      });

      setActions(nextActions);
    },
    [command, defaultActions, roles],
  );

  const resetActions = useCallback(() => setActions({ ...defaultActions }), [defaultActions]);

  return { actions, commandAction, resetActions };
};

export default useCommandActions;
